module.exports = __webpack_public_path__ + "static/Five Considerations When-Designing-an-MVP-for-Your-Startup-029155f4037c6a75a78d88eee8c37078.png";